/* VialArt / VialCase — cart design guard.
   A label line with NO design attached (missing _template/_design/_config_enc/
   _upload_id — possible via direct /cart/add.js calls or odd channel paths)
   must not reach checkout. This guard:
     - flags such lines in the cart page + cart drawer with a Remove button
     - blocks the checkout submit/click (capture phase) while any exist
     - hides accelerated checkout (Shop Pay etc.) while any exist
   Server-side safety net stays in Label Farm (no-design order flag).
   Identical file ships to BOTH themes; product IDs don't collide. */
(function () {
  var LABEL_PRODUCTS = {
    // VialArt
    10248497955092: 1, // Design Your Label
    10266061832468: 1, // Commercial / Branded Labels
    // VialCase
    8311522132025: 1,  // Custom Vial Labels (holographic)
    8326237061177: 1   // Commercial / Branded Labels
  };
  var DESIGN_PROPS = ['_template', '_design', '_config_enc', '_upload_id'];
  var badLines = [];   // [{key,title,variant}]
  var working = false;

  function hasDesign(props) {
    if (!props) return false;
    for (var i = 0; i < DESIGN_PROPS.length; i++) {
      var v = props[DESIGN_PROPS[i]];
      if (v != null && String(v) !== '') return true;
    }
    return false;
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function ensureCss() {
    if (document.getElementById('va-cg-css')) return;
    var st = document.createElement('style');
    st.id = 'va-cg-css';
    st.textContent =
      '.va-cg{margin:0 0 14px;padding:12px 14px;border-radius:12px;background:linear-gradient(135deg,#3a1020,#4a1425);'
      + 'border:1px solid rgba(248,113,113,.55);color:#fff;font:600 13px/1.4 system-ui,-apple-system,sans-serif;}'
      + '.va-cg__h{font-weight:800;margin:0 0 6px;color:#fecaca;}'
      + '.va-cg__row{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:6px 0;}'
      + '.va-cg__btn{flex:none;background:#7f1d1d;color:#fff;border:1px solid rgba(248,113,113,.6);border-radius:8px;'
      + 'padding:6px 12px;font:700 12px/1 system-ui,-apple-system,sans-serif;cursor:pointer;}'
      + '.va-cg__btn:disabled{opacity:.5;cursor:wait;}'
      + 'body[data-va-cg-block] shopify-accelerated-checkout-cart,'
      + 'body[data-va-cg-block] shopify-accelerated-checkout,'
      + 'body[data-va-cg-block] .additional-checkout-buttons{display:none !important;}';
    document.head.appendChild(st);
  }

  function boxHTML() {
    var h = '<div class="va-cg__h">&#9888;&#65039; This item has no label design attached</div>';
    for (var i = 0; i < badLines.length; i++) {
      var b = badLines[i];
      h += '<div class="va-cg__row"><span>' + b.title + '</span>'
        + '<button type="button" class="va-cg__btn" data-va-cg-remove="' + b.key + '">Remove</button></div>';
    }
    h += '<div style="font-weight:500;color:#fca5a5;margin-top:6px;">Remove it (or design it in the builder) to continue to checkout.</div>';
    return h;
  }
  function placeBox(container, id) {
    if (!container) return;
    var el = document.getElementById(id);
    if (!badLines.length) { if (el) el.remove(); return; }
    if (!el || !container.contains(el)) {
      if (el) el.remove();
      el = document.createElement('div');
      el.id = id;
      el.className = 'va-cg';
      el.setAttribute('role', 'alert');
      container.insertBefore(el, container.firstChild);
    }
    var html = boxHTML();
    if (el.getAttribute('data-sig') !== html) { el.setAttribute('data-sig', html); el.innerHTML = html; }
  }
  function render() {
    ensureCss();
    if (badLines.length) document.body.setAttribute('data-va-cg-block', '1');
    else document.body.removeAttribute('data-va-cg-block');
    placeBox(document.querySelector('.cart-drawer__content'), 'va-cg-drawer');
    if (location.pathname.indexOf('/cart') === 0) {
      placeBox(document.querySelector('.cart-page') || document.getElementById('MainContent'), 'va-cg-page');
    }
  }

  function sync() {
    return getCart().then(function (cart) {
      var bad = [];
      (cart.items || []).forEach(function (it) {
        if (LABEL_PRODUCTS[it.product_id] && !hasDesign(it.properties)) {
          var t = it.product_title || 'Label';
          if (it.variant_title) t += ' — ' + it.variant_title;
          bad.push({ key: it.key, title: t });
        }
      });
      badLines = bad;
      render();
    }).catch(function () {});
  }

  // Remove buttons
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-va-cg-remove]');
    if (!btn || working) return;
    working = true; btn.disabled = true;
    removeLine(btn.getAttribute('data-va-cg-remove')).then(function () {
      working = false;
      if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
      sync();
    }).catch(function () { working = false; btn.disabled = false; });
  }, true);

  function isCheckoutControl(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('#checkout,[name="checkout"],a[href^="/checkout"],.cart__checkout-button');
  }
  function block(e) {
    e.preventDefault();
    e.stopPropagation();
    var box = document.getElementById('va-cg-page') || document.getElementById('va-cg-drawer');
    if (box && box.scrollIntoView) box.scrollIntoView({ block: 'center' });
  }
  // Capture-phase: block checkout clicks + form submits while bad lines exist
  document.addEventListener('click', function (e) {
    if (badLines.length && isCheckoutControl(e.target)) block(e);
  }, true);
  document.addEventListener('submit', function (e) {
    if (!badLines.length) return;
    var f = e.target;
    var sub = e.submitter;
    var isCheckout = (sub && sub.name === 'checkout') || (f && f.querySelector && f.querySelector('[name="checkout"]') && String(f.action || '').indexOf('/cart') !== -1);
    if (isCheckout) block(e);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  // Re-check after any cart mutation (chained fetch patch, same as va-freegift).
  var deb;
  function schedule() { clearTimeout(deb); deb = setTimeout(sync, 350); }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (typeof input === 'string') ? input : String((input && (input.url || input.href)) || ''); } catch (e) {}
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) { p.then(schedule, function () {}); }
      return p;
    };
  }
  // Survive Horizon section morphing (re-inject the box)
  try {
    var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(render, 150); });
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    if (location.pathname.indexOf('/cart') === 0) {
      var main = document.getElementById('MainContent');
      if (main) mo.observe(main, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
